import { render, staticRenderFns } from "./UnitOfMeasurementCreateUpdate.vue?vue&type=template&id=31e5e7d0&"
import script from "./UnitOfMeasurementCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./UnitOfMeasurementCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports